import { Component, HostListener, Input, OnDestroy, OnInit} from '@angular/core';
import { Constant } from '../../../environments/constants';
import { Subscription } from 'rxjs';
import { DataService } from '../../services/context/data.service';
import { UIStateService } from '../../services/context/uistate.service';
import { AppMonitoringService } from '../../services/util/app-monitoring.service';
import * as fromModel from '../../services/models';
import * as Highcharts from 'highcharts';
//import addMore from "highcharts/highcharts-more";
import { Utils } from '../../../utils/utils';
//addMore(Highcharts)

// import HC_exporting from 'highcharts/modules/exporting';
// HC_exporting(Highcharts);

// import HC_more from 'highcharts/highcharts-more'
// HC_more(Highcharts);

import HC_sankey from 'highcharts/modules/sankey';
import { FormControl, Validators } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
HC_sankey(Highcharts);

@Component({
  selector: 'gp-net-cash-flow-by-year',
  templateUrl: './net-cash-flow-by-year.component.html',
  styleUrls: ['./net-cash-flow-by-year.component.scss']
})
export class NetCashFlowByYearComponent implements OnInit, OnDestroy {

  protected _storeDataSubscription: Subscription;
  protected _uiStateSubscription: Subscription;

  Highcharts: typeof Highcharts = Highcharts;
  options: Highcharts.Options;
  private chart: Highcharts.Chart;

  isDataAvailable = false;
  yoyCashFlows;
  appliedPlan;
  yearHint;
  

  nCFAdditionalOutput: fromModel.NetCashFlowOutput;

  year = new FormControl('', [Validators.required, Validators.maxLength(4)]);
  
  constructor(private dataService: DataService,
      private uiStateService: UIStateService,  
      private appMonitoringService: AppMonitoringService) {    
        this.year.setValue((new Date()).getFullYear());
  }

  ngOnInit(): void {
    //this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWPROGRESSBAR, "NetCashFlowByYearComponent-ngOnInit", true);
    this.dataService.getPlanAnalysis();    
    this._storeDataSubscription = this.dataService.subscribe((appData: fromModel.IAppData) => this.populateAppData(appData));   
    this._uiStateSubscription =  this.uiStateService.subscribe((uiState: fromModel.IUIState) => this.populateUIContext(uiState));     
    
    
    this.year.valueChanges
    .pipe(
      debounceTime(100)
    ).subscribe (
      value => {
        this.setChartOptionsData();
      }
    );
  }

  setYearValueBy(value){
    let year;
    switch(value){
      case "C1RET":
        year = this.nCFAdditionalOutput.c1RetYear;
        break;
      case "C2RET":
        year = this.nCFAdditionalOutput.c2RetYear;
        break;
      case "PLANSTART":
        year = this.appliedPlan.startYr;
        break;
      case "PLANEND":
        year = this.appliedPlan.endYr;
        break;
    }
    this.year.setValue(year);
  }

  private populateAppData(appData: fromModel.IAppData){    
      this.yoyCashFlows = null;
      this.isDataAvailable = false;
      if(appData && (appData.action===fromModel.DATA_ACTION.UPDATESETTINGS)){        
        this.dataService.getGoalSummary();
        this.dataService.getPlanAnalysis();      
      } else {
      if(appData && appData.action!==fromModel.DATA_ACTION.NONE){              
        let yoyCFs = this.dataService.getPlanAnalysisyoyCashFlows();
        if(yoyCFs!== null){
          if(yoyCFs.Error){
            this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWERRORMSG, "NetCashFlowByYearComponent-populateAppData - Error", {ShowMsg: true,  MsgType: fromModel.MSGTYPE.ERROR, Msg: Constant.ErrorMsgs.analyticErrorMsg});
          } else {
            this.yoyCashFlows =  yoyCFs;
            this.appliedPlan = this.dataService.getAppliedPlan();
            if(this.appliedPlan && this.appliedPlan.startYr && this.appliedPlan.endYr){
              this.yearHint = `${this.appliedPlan.startYr}-${this.appliedPlan.endYr}`;
            }
            
            this.setChartOptionsData();
            this.isDataAvailable = true;
            this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWPROGRESSBAR, "NetCashFlowByYearComponent-populateAppData", false);
          }
        }
      }
    }
  }

  populateUIContext(uiState: fromModel.IUIState){     
    if(uiState && uiState.action === fromModel.UI_STATE_ACTION.REFRESH){
      if(uiState.Refresh){
        this.resizeChart();
        this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.REFRESH, "NetCashFlowByYearComponent-populateUIContext", false);        
      }
      
    }
  }

  private setChartOptionsData(){

    this.options = { 
      chart: {
        type: 'sankey',
        style: {
          fontSize: '18'
        } 
      },          
      title: {
          text: ''
      },     
      credits: {
        enabled: false
      },   
      tooltip:{
        enabled: true,          
        useHTML: true,
        style:{
          color: '4F528C', 
          fontSize: '14',
          fontFamily: 'Avenir',
          fontWeight: 'bold'
        },
        formatter: function() {
          if(this.point['from']){
            if(this.point['weight']>1){
              return this.point['from'] + ' → ' + this.point['to'] + ': $' + Highcharts.numberFormat(this.point['weight'],0,'.',',');
            } else {
              return this.point['from'] + ' → ' + this.point['to'] + ': <$1';
            }
          } else {
            if(this.point['sum']>1){
              return this.point['name'] + ': $' + Highcharts.numberFormat(this.point['sum'],0,'.',',');
            } else {
              return this.point['name'] +': <$1';
            }
          }
        }
      },
      plotOptions: {
        sankey: {
          dataLabels: {
            enabled: true,
            useHTML: true,
            style: {
              fontSize: '14',
              fontFamily: 'Avenir',
              color: '#353459',                                
              textOutline: 'none'
            },
            nodeFormatter: function() {
              if(this.point['sum']>1){
                return this.point.name +': $' + Highcharts.numberFormat(this.point['sum'],0,'.',',');
              } else {
                return this.point.name +': <$1';
              }              
            }
          }
        }
      },
      series : []
    }    
    //this.options = <Highcharts.Options>Utils.getDefaultSankeyChartOptions();
    
    let { series } = this.options;
    series = this.getChartData(series);
    this.options = {...this.options, series};    
  }

  private getChartData(series){    
    //let chartSeries = this.dataService.getChartSeries({chartSeriesType: fromModel.CHARTSERIESTYPE.NETCASHFLOWSBYTEAR, year: 2077});
    let chartSeries = this.dataService.getChartSeries({chartSeriesType: fromModel.CHARTSERIESTYPE.NETCASHFLOWSBYTEAR, year: this.year.value});
    if(chartSeries && chartSeries.series && chartSeries.series.length>0){
      chartSeries.series.forEach(ser => {
        series.push(ser);  
      });    

      this.nCFAdditionalOutput = chartSeries.nCFAdditionalOutput;      
    }    
    //let chartSeries = this.dataService.getChartSeries({chartSeriesType: fromModel.CHARTSERIESTYPE.NETCASHFLOWSBYTEAR, year: this.year.value});
    //series.push(this.dataService.getChartSeries({chartSeriesType: fromModel.CHARTSERIESTYPE.AGE}).series[0]);    
    return series;
  }


  @HostListener('window:resize', ['$event'])
  onResize(){
    if(this.chart) {
      this.chart.reflow();
    }
  }

  resizeChart(){
    setTimeout(() => {
      if(this.chart && this.chart.hasOwnProperty('series')) {
        this.chart.reflow();
      }
    }, 200);
  }

  public chartCallBack = (chart: Highcharts.Chart) => {
    this.chart =  chart;
    setTimeout(() => {
      if(this.chart && this.chart.hasOwnProperty('series')) {
        this.chart.reflow();
      }
    }, 100);
  }

  ngOnDestroy(): void{
    if(this._storeDataSubscription && this._storeDataSubscription !== null){
      this._storeDataSubscription.unsubscribe();
    }
    if(this._uiStateSubscription && this._uiStateSubscription !== null){
      this._uiStateSubscription.unsubscribe();    
    }    
  }
}